<!--
<template>
  <div class="relative">
    <nav
      :class="[
        'z-50 transition-all duration-400 ease-in-out',

        // 滚动跟随条件独立控制
        shouldAlwaysFix ? 'relative' : 'fixed top-0 left-0 right-0',
        // 背景颜色条件独立控制，滚动时isScrolled变为白色，未滚动时渐变
        shouldAlwaysWhite || isScrolled
          ? 'bg-white shadow-md'
          : 'bg-gradient-to-b from-neutral-400/50 to-neutral-400/0',
      ]"
      class="w-full h-[6.46vw] flex justify-center"
    >
      &lt;!&ndash; info &ndash;&gt;
      <div
        class="w-[61.46vw] h-[2.55vw] absolute mt-[1.2vw] flex justify-between"
      >
        &lt;!&ndash; **Logo 左上角** &ndash;&gt;
        <img
          src="@/assets/images/Header/logo.png"
          alt="蓝悦logo"
          class="object-cover w-auto h-full"
        />

        &lt;!&ndash; **电话图标 右上角** &ndash;&gt;
        &lt;!&ndash; <img
          src="@/assets/images/Header/tel.png"
          alt="蓝悦tel"
          class="object-cover w-auto h-full"
        /> &ndash;&gt;
        <div class="flex flex-col w-auto h-full">
          <p
            class="text-[1.04vw] text-[#F28334] font-bold font-harmony text-end"
          >
            400 0336 691
          </p>
          <p
            class="text-[0.63vw] text-[#676B73] font-regular font-harmony text-end"
          >
            全天24小时加盟热线
          </p>
        </div>
      </div>

      &lt;!&ndash; 内部内容框 &ndash;&gt;
      <div
        ref="navContainer"
        class="w-[61.46vw] h-[1.82vw] relative mt-[4.58vw]"
      >
        &lt;!&ndash; 主菜单文字模块 &ndash;&gt;
        <div
          class="w-[61.46vw] h-[0.99vw] relative top-0 left-0 flex justify-between"
        >
          <HeaderItem
            v-for="(item, index) in headerItems"
            :key="index"
            :label="item.label"
            :items="item.items"
            :path="item.path"
            :shouldAlwaysWhite="shouldAlwaysWhite"
            :shouldAlwaysFix="shouldAlwaysFix"
            @nav-hover="updateUnderline"
            @nav-leave="hideUnderline"
          />
        </div>

        &lt;!&ndash; 全局连续的灰色下划线：只有当页面未滚动时才显示 &ndash;&gt;
        <div
          v-if="!isScrolled"
          class="absolute bottom-0 left-0 w-full h-[0.16vw] bg-[#F5F5F7]/30"
          style="z-index: 0"
        ></div>
      </div>
    </nav>
    &lt;!&ndash; 添加占位元素，当固定定位时保持布局空间 &ndash;&gt;
    <div v-if="shouldAlwaysWhite" class="h-[6.46vw] w-full"></div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import HeaderItem from "./HeaderItem.vue";

export default {
  name: "HeaderBar",
  props: {
    shouldAlwaysWhite: {
      type: Boolean,
      default: true,
    },
    shouldAlwaysFix: {
      type: Boolean,
      default: false,
    },
  },
  components: { HeaderItem },
  setup() {
    const isScrolled = ref(false);
    const navContainer = ref(null);
    const underlineLeft = ref(0);
    const underlineWidth = ref(0);
    const underlineVisible = ref(false);

    const headerItems = ref([
      {
        label: "首页",
        path: "/",
        items: [
          //
        ],
      },
      {
        label: "关于我们",
        path: "/AboutUs",
        items: [
          // "公司简介", "办公环境", "集团大事记", "合作伙伴"
        ],
      },
      {
        label: "课程体系",
        path: "/CourseSystem",
        items: [
          // "编程课程", "机器人课程", "竞赛培训"
        ],
      },
      {
        label: "白名单赛事",
        path: "/Competition",
        items: [
          //  "竞赛介绍", "证书信息"
        ],
      },
      {
        label: "全国加盟",
        path: "/JoinUs",
        items: [
          // "加盟条件", "加盟流程", "成功案例"
        ],
      },
      {
        label: "新闻中心",
        path: "/News",
        items: [
          //  "最新动态", "媒体报道", "行业资讯"
        ],
      },
      {
        label: "联系我们",
        path: "/ContactUs",
        items: [
          // "联系我们", "在线留言", "公司地址"
        ],
      },
    ]);

    const handleScroll = () => {
      isScrolled.value = window.scrollY > 0;
    };

    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });

    // 更新蓝色下划线位置和宽度
    const updateUnderline = (el) => {
      if (navContainer.value && el) {
        const containerRect = navContainer.value.getBoundingClientRect();
        const itemRect = el.getBoundingClientRect();
        underlineLeft.value = itemRect.left - containerRect.left;
        underlineWidth.value = itemRect.width;
        underlineVisible.value = true;
      }
    };

    // 隐藏蓝色下划线
    const hideUnderline = () => {
      underlineVisible.value = false;
    };

    return {
      isScrolled,
      navContainer,
      underlineLeft,
      underlineWidth,
      underlineVisible,
      updateUnderline,
      hideUnderline,
      headerItems,
    };
  },
};
</script>
-->
<template>
    <div class="relative" id="headerBarElement">
        <nav
                :class="[
        'z-50 transition-all duration-400 ease-in-out',
        shouldAlwaysFix ? 'relative' : 'fixed top-0 left-0 right-0',
        (shouldAlwaysWhite || isScrolled)
          ? 'bg-white shadow-md'
          : 'bg-gradient-to-b from-neutral-400/50 to-neutral-400/0'
      ]"
                class="w-full h-[6.46vw] flex justify-center"
        >
            <!-- info -->
            <div class="w-[61.46vw] h-[2.55vw] absolute mt-[1.2vw] flex justify-between info-bar">
                <!-- Logo -->
                <img
                        src="@/assets/images/Header/logo.png"
                        alt="蓝悦logo"
                        class="object-cover w-auto h-full"
                />

                <!-- 联系电话 -->
                <div class="flex flex-col w-auto h-full">
                    <p class="text-[1.04vw] text-[#F28334] font-bold font-harmony text-end">
                        400 0336 691
                    </p>
                    <p class="text-[0.63vw] text-[#676B73] font-regular font-harmony text-end">
                        全天24小时加盟热线
                    </p>
                </div>
            </div>

            <!-- 内部内容框 -->
            <div ref="navContainer" class="w-[61.46vw] h-[1.82vw] relative mt-[3.6vw]">
                <!-- 主菜单 -->
                <div class="w-[61.46vw] h-[2.5vw] relative top-0 left-0 flex justify-between">
                    <HeaderItem
                            v-for="(item, index) in headerItems"
                            :key="index"
                            :label="item.label"
                            :items="item.items"
                            :path="item.path"
                            :should-always-white="shouldAlwaysWhite"
                            :should-always-fix="shouldAlwaysFix"
                            :elementRef="item.elementRef"
                            :busMethod="item.busMethod"
                            @nav-hover="updateUnderline"
                            @nav-leave="hideUnderline"
                    />
                </div>

                <!-- 灰色下划线 -->
                <div
                        v-if="!isScrolled"
                        class="absolute bottom-0 left-0 w-full h-[0.16vw] bg-[#F5F5F7]/30"
                        style="z-index: 0"
                ></div>
            </div>
        </nav>
        <!-- 占位元素 -->
        <div v-if="shouldAlwaysWhite" class="h-[6.46vw] w-full"></div>
    </div>
</template>

<script>
import HeaderItem from './HeaderItem.vue'

export default {
    name: 'HeaderBar',
    components: {
        HeaderItem
    },
    props: {
        shouldAlwaysWhite: {
            type: Boolean,
            default: true
        },
        shouldAlwaysFix: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isScrolled: false,
            underlineLeft: 0,
            underlineWidth: 0,
            underlineVisible: false,
            headerItems: [
                {
                    label: '首页',
                    path: '/',
                    items: []
                },
                {
                    label: '关于我们',
                    path: '/AboutUs',
                    items: ['企业简介','专家顾问','荣誉资质','合作单位','发展历程'],
                    elementRef:['about2','about3','about4','about5','about6'],
                    busMethod:'scroll-to-about'
                },
                {
                    label: '课程体系',
                    path: '/CourseSystem',
                    items: ['校内课程','周末班','研学路线','寒暑假班','学生风采'],
                    elementRef:['course2','course3','course4','course5','course6'],
                    busMethod:'scroll-to-course'
                },
                {
                    label: '白名单赛事',
                    path: '/Competition',
                    items: ['赛事介绍','赛事集锦','获奖证书'],
                    elementRef:['competition2','competition3','competition5'],
                    busMethod:'scroll-to-competition'
                },
                {
                    label: '全国加盟',
                    path: '/JoinUs',
                    items: ['加盟计划','加盟流程','项目扶持','合作申请'],
                    elementRef:['join2','join3','join4','join5'],
                    busMethod:'scroll-to-join'
                },
                {
                    label: '新闻中心',
                    path: '/News',
                    items: ['公司新闻','加盟动态','行业资讯'],
                    elementRef:['company','join','industry'],
                    busMethod:''
                },
                {
                    label: '联系我们',
                    path: '/ContactUs',
                    items: []
                }
            ]
        }
    },
    methods: {
        handleScroll() {
            this.isScrolled = window.scrollY > 0
        },
        updateUnderline(el) {
            if (this.$refs.navContainer && el) {
                const containerRect = this.$refs.navContainer.getBoundingClientRect()
                const itemRect = el.getBoundingClientRect()
                this.underlineLeft = itemRect.left - containerRect.left
                this.underlineWidth = itemRect.width
                this.underlineVisible = true
            }
        },
        hideUnderline() {
            this.underlineVisible = false
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>
